import type { ReactNode } from 'react'

import type { UserRole } from '@/api/types'
import { ROLE_LABELS } from '@/auth/permissions'
import { cn } from '@/lib/cn'

type Tone = 'neutral' | 'primary' | 'success' | 'error' | 'warning' | 'info'

const TONES: Record<Tone, string> = {
  neutral: 'bg-surface-container-high text-on-surface-variant',
  primary: 'bg-primary text-on-primary',
  success: 'bg-success-container text-on-success-container',
  error: 'bg-error text-on-error',
  warning: 'bg-warning-container text-on-warning-container',
  info: 'bg-primary/10 text-primary',
}

export function Badge({
  tone = 'neutral',
  children,
  className,
}: {
  tone?: Tone
  children: ReactNode
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1',
        'text-[11px] font-bold uppercase tracking-wide',
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  )
}

const ROLE_TONES: Record<UserRole, Tone> = {
  OWNER: 'primary',
  ADMIN: 'info',
  TEACHER: 'neutral',
}

export function RoleBadge({ role }: { role: UserRole }) {
  return <Badge tone={ROLE_TONES[role]}>{ROLE_LABELS[role]}</Badge>
}

export function StatusBadge({ isActive }: { isActive: boolean }) {
  return (
    <Badge tone={isActive ? 'success' : 'neutral'}>{isActive ? 'Aktywne' : 'Nieaktywne'}</Badge>
  )
}
